import { GridAction } from '@eforall/dashboard';
import { Gift } from '@interfaces';

export function getActions() {

	const actions: GridAction<Gift>[] = [
	];

	return actions;
}